
function Header3Row({report, row, index, onHide}){
    return <tr onClick={() => onHide(index)}>
        <td style={{padding: "0 10px 0 10px"}}>
            <h3 style={{
                fontFamily: report.config.template.templateFonts.headings,
                fontWeight: "bold",
                fontSize: "16px",
                color: report.config.template.templateColors.secondary
            }}>{row.content}</h3>
        </td>
    </tr>;
}
export default Header3Row;